import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-layouts-and-navigation-page-ui',
    templateUrl: 'bb-layouts-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbLayoutsPageUiComponent {
}
